import axios from 'axios';
import { processResponse, processError } from '../utils';
export default class HeroShortenerAPI {
    static expandShortlink(constAccessParams, shortlink) {
        return axios
            .get(constAccessParams.API_ENDPOINT + 'link/' + shortlink)
            .then(function (response) {
            return processResponse(response);
        })
            .catch(function (error) {
            return processError(error);
        });
    }
}
//# sourceMappingURL=index.js.map